import React, { useState } from "react";
import styles from "./HeroContent.module.css";

interface HeroContentProps {
  onOpenModal: () => void;
}

const STORAGE_BUCKET = "mindscriberweb3.firebasestorage.app";

const imageUrl = (width: number) =>
  `https://firebasestorage.googleapis.com/v0/b/${STORAGE_BUCKET}/o/${encodeURIComponent(
    `scriber-o/${width}.webp`,
  )}?alt=media`;

export const HeroContent: React.FC<HeroContentProps> = ({ onOpenModal }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <main className={styles.mainContent}>
      <div className={styles.textContent}>
        <h1 className={styles.headline}>
          AI&rsquo;s missing
          <br />
          human input
        </h1>
        {/* for desktop and tablet */}
        <p className={`${styles.description} ${styles.descriptionDesktop}`}>
          Scriber O turns physiological context into AI <br /> input, so your
          body can speak before words.
        </p>
        {/* only for mobile */}
        <p className={`${styles.description} ${styles.descriptionMobile}`}>
          Scriber O turns physiological <br /> context into AI input, so your
          <br />
          body can speak before words.
        </p>
      </div>
      <button
        type="button"
        className={styles.accessButton}
        onClick={onOpenModal}
        aria-label="Request enterprise access"
      >
        Access
      </button>

      <div className={styles.visualContent}>
        <picture>
          <source media="(max-width: 374px)" srcSet={imageUrl(360)} />
          <source media="(max-width: 410px)" srcSet={imageUrl(768)} />
          <source media="(max-width: 600px)" srcSet={imageUrl(834)} />
          <source media="(max-width: 800px)" srcSet={imageUrl(1024)} />
          <source media="(max-width: 999px)" srcSet={imageUrl(834)} />
          <source media="(max-width: 1200px)" srcSet={imageUrl(834)} />
          <source media="(max-width: 1400px)" srcSet={imageUrl(1024)} />
          <source media="(max-width: 1700px)" srcSet={imageUrl(1440)} />
          <img
            src={imageUrl(1920)}
            alt="Scriber O wearable device"
            className={styles.heroImage}
            onLoad={() => setIsLoaded(true)}
            style={{ opacity: isLoaded ? 1 : 0, transition: "opacity 0.4s" }}
            fetchPriority="high"
            loading="eager"
            decoding="async"
          />
        </picture>
      </div>
    </main>
  );
};
